<template>
  <div>
    <v-app-bar
      class=""
      app
      color="#350078"
      dark
      style="margin: 0 auto; box-shadow: none;"
    >
      <v-btn @click="drawer = !drawer" icon>
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <img src="../assets_aluno/logotipo_cem_branco2.svg" class="logo-navbar" />
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute class="primary " dark>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            ><br /><br /><br /><b>CONFIGURAÇÕES</b><br /><br
          /></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link @click="edit = !edit">
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>EDITAR PERFIL</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/cadastro-aulas">
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>CADASTRAR HORÁRIOS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/professor">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>HOME</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$store.dispatch('logout')">
          <v-list-item-icon>
            <v-icon>mdi-exit-run</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>SAIR</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="teacher-app-bg pl-0 pr-0">
      <!-- <p class=<p class="register-agenda-preview-time text-center mb-1 px-5">
        Clique nos seus
      </p> -->
      <p class="register-agenda-title text-center  mb-1">
        Meus Horários
        <br />Disponíveis
      </p>
      <div class="register-agenda-subtitle">
        Selecione sua rotina semanal de horários disponíveis para aulas particulares.
      </div>
      <!-- <p class="register-agenda-title text-center  mb-1">
        Cem floripa
        <br />
        <span style="font-weight: 400; font-size: 18px; text-transform: capitalize;">Matemática</span>
      </p> -->

      <v-col
        cols="7"
        sm="3"
        lg="2"
        class="mx-auto text-center select-subject pb-0"
      >
        <v-select
          solo
          flat
          v-model="isHome"
          :items="homeSchoolCem"
          :menu-props="{ maxHeight: '400' }"
          label="Tipo de aula"
          item-text="name"
          item-value="id"
          persistent-hint
          :hide-details="true"
        ></v-select>
      </v-col>

      <v-col
        cols="7"
        sm="3"
        lg="2"
        class="mx-auto text-center select-subject pb-0"
      >
        <v-select
          solo
          flat
          v-if="affiliates"
          v-model="affiliateId"
          :items="affiliatesWtihHomeschool"
          :menu-props="{ maxHeight: '400' }"
          label="Filial"
          item-text="name"
          item-value="id"
          persistent-hint
          :hide-details="true"
        ></v-select>
      </v-col>

      <v-col
        cols="7"
        sm="3"
        lg="2"
        class="mx-auto text-center select-subject pb-0"
      >
        <v-select
          solo
          flat
          v-model="subjectId"
          :items="subjects"
          :menu-props="{ maxHeight: '400' }"
          label="Matéria"
          item-text="name"
          item-value="id"
          persistent-hint
        ></v-select>
      </v-col>
      <v-row class="agenda mx-auto" no-gutters style="max-width: 500px;">
        <v-col cols="6" @click="prevPage">
          <div class="btn-change-date my-8 roxo">
            <v-icon @click="prevPage" color="#440099" small
              >mdi-arrow-left</v-icon
            >
            Dia anterior
          </div>
        </v-col>

        <v-col cols="6">
          <div
            v-on:click="nextPage"
            class="btn-change-date my-8 text-right roxo"
          >
            Próximo dia
            <v-icon color="#440099" small>mdi-arrow-right</v-icon>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" no-gutters class="px-2 mb-8" v-if="subjectId && affiliateId">
        <AgendaDate
          v-for="agenda in slicedProfessors"
          :key="agenda.weekdayIndex"
          :agenda-object="agenda"
          :scheduled-dates="getFreeTimeAgenda"
          :selected-dates="selectedDates"
          :remove-dates="removeDates"
          :affiliate-id="affiliateId"
          :homeschool="isHome > 0"
          :subject-id="subjectId"
          @selected="onSelectedAgendaDate"
        />
      </v-row>
      <div class="pl-9 pr-9 text-center">
        <v-btn
          @click="saveAgendaChanges"
          color="primary"
          rounded
          depressed
          large
          class="mt-12 mb-8"
          >Salvar alterações</v-btn
        >
        <br />
        <v-btn v-if="false" @click="deleteAgenda" rounded outlined class="mt-8 mb-8 py-3"
          >Limpar agenda</v-btn
        >
        <!-- <hr color="lightgrey" style="max-width: 200px; margin: 0 auto;" /> -->
        <v-btn rounded outlined small class="mt-8">Cancelar</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AgendaDate from "@/components/teacher/AgendaDate";
import professorsAgenda from "@/models/professorsAgenda";
import professorsAgendaCEM from "@/models/professorsAgendaCEM";
import ProfessorsRepository from "@/repositories/ProfessorsRepository";
import { mapGetters, mapState } from "vuex";
import AdminRepository from "@/repositories/AdminRepository";

export default {
  components: {
    AgendaDate
  },
  data() {
    return {
      drawer: undefined,
      edit: undefined,
      offset: [0, 3],
      homeSchoolCem: [{ name: 'No cem', id: 0 }, { id: 1, name: 'Em casa' }],
      isHome: 0,
      professorsAgenda: professorsAgenda,
      professorsAgendaCEM: professorsAgendaCEM,
      subjectId: undefined,
      affiliateId: undefined,
      affiliates: [],
      selectedDates: [],
      removeDates: [],
      cant_edit: false
    };
  },

  computed: {
    filteredScheduledTimes() {
      return this.getFreeTimeAgenda.filter(item => this.isHome > 0 ? item.homeschool : !item.homeschool)
    },

    affiliatesWtihHomeschool() {
      return this.affiliates
    },

    filteredProfessors() {
      const professorsList = this.isHome > 0 ? this.professorsAgenda : this.professorsAgendaCEM

      return professorsList.filter(
        agenda => agenda.availableHours.length
      );
    },

    slicedProfessors() {
      return this.filteredProfessors.slice(this.offset[0], this.offset[1]);
    },

    ...mapGetters(["getFreeTimeAgenda"]),
    ...mapState(["subjects", "affiliate", "userProfile"])
  },

  beforeMount() {
    this.$store.dispatch("loadProfessorStore");
  },

  async mounted() {
    const response = await AdminRepository.listAffiliates();
    this.affiliates = response.data

    if ( !this.userProfile.user.edit_schedule ) {
      this.cant_edit = true
    }
  },

  methods: {
    nextPage() {
      if (this.offset[1] === this.filteredProfessors.length) return false;
      this.offset = [this.offset[0] + 1, this.offset[1] + 1];
    },

    prevPage() {
      if (this.offset[0] === 0) return false;
      this.offset = [this.offset[0] - 1, this.offset[1] - 1];
    },

    onSelectedAgendaDate(event) {
      const alreadyScheduled = this.getFreeTimeAgenda.findIndex(selectedDate => selectedDate.affiliate === event.affiliate && selectedDate.subject === event.subject && selectedDate.date === event.date);
      if (alreadyScheduled > -1) {
        const alreadyRemoved = this.removeDates.findIndex(selectedDate => selectedDate.affiliate === event.affiliate && selectedDate.subject === event.subject && selectedDate.date === event.date);
        if (alreadyRemoved > -1) {
          this.removeDates.splice(alreadyRemoved, 1);

        } else {
          this.removeDates.push(event);
        }
      } else {
        const index = this.selectedDates.findIndex(selectedDate => selectedDate.affiliate === event.affiliate && selectedDate.subject === event.subject && selectedDate.date === event.date);
        const alreadySelect = this.selectedDates.findIndex(selectedDate =>  selectedDate.date === event.date);

        const uniqString = event.date;
        if (index >= 0) {
          this.selectedDates.splice(index, 1);
          } else {
          this.selectedDates.push(event);
        }
      }
    },

    async saveAgendaChanges() {
      const response = await ProfessorsRepository.saveAgenda(
        this.selectedDates,
        this.subjectId || this.subjects[0].id,
        this.affiliateId,
        this.removeDates
      );

      this.$store.dispatch("loadProfessorStore");
      this.$router.push("/professor");
    },

    async deleteAgenda() {
      const response = await ProfessorsRepository.deleteAgenda(
        this.selectedDates,
        this.subjectId || this.subjects[0].id,
        this.affiliate.id
      );
    }

  }
};
</script>

<style scoped>
/* estilo navbar */
.logo-navbar {
  height: 90%;
}

.teacher-app-bg {
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  /* max-width: 415px; */
  margin: 0 auto;
  /* min-height: 100%; */
  padding: 60px 32px 90px;
  background: rgba(244, 244, 252, 1);
  background: -moz-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(244, 244, 252, 1)),
    color-stop(100%, rgba(240, 240, 250, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(243, 243, 251, 11) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(243, 243, 251, 1) 0%,
    rgba(240, 240, 250, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f4f4fc', endColorstr='#f0f0fa', GradientType=0 );
}
.register-agenda-title {
  text-align: center;
  text-transform: uppercase;
  color: #440099;
  font-weight: 900;
  font-size: 24px;
  line-height: 1.1;
}
.register-agenda-subtitle {
  text-align: center;
  color: #a09aab;
  font-weight: 400;
  font-size: 16px;
  margin: 13px auto 24px;
  max-width: 420px;
}
.font-18 {
  font-size: 18px;
}
.register-agenda-preview-day {
  font-size: 16px;
  font-weight: 900;
  color: #a09aab;
  text-transform: uppercase;
  padding-right: 12px;
}
.register-agenda-preview-time {
  color: #a09aab;
}

.select-subject >>> .v-select__selection {
  color: #440099;
  font-weight: 900;
  text-transform: uppercase;
  /* text-align: center; */
  /* margin: 7px auto; */
}

.agenda {
  padding: 6px;
}
.btn-change-date {
  color: #ffffff;
  line-height: 2;
  font-size: 13px;
  cursor: pointer;
}
p.agenda-date {
  color: #44ff99;
  font-size: 21px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
}
.agenda-date span {
  font-weight: 400;
  font-style: italic;
  color: #ffffff;
}
.agenda-time {
  height: 70px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 2px 1px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  /* background: rgba(255, 255, 255, 0.4);
  background: -moz-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(255, 255, 255, 0.4)),
    color-stop(100%, rgba(255, 255, 255, 0.5))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff', GradientType=1 ); */
  background: rgb(156, 114, 255);
  background: -moz-linear-gradient(
    325deg,
    rgba(156, 114, 255, 1) 0%,
    rgba(190, 138, 255, 1) 100%
  );
  background: -webkit-linear-gradient(
    325deg,
    rgba(156, 114, 255, 1) 0%,
    rgba(190, 138, 255, 1) 100%
  );
  background: linear-gradient(
    325deg,
    rgba(156, 114, 255, 1) 0%,
    rgba(190, 138, 255, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#9c72ff",endColorstr="#be8aff",GradientType=1);
}
.agenda-time:hover {
  background: rgba(68, 0, 153, 0.8);
}
.agenda-time:active {
  background: rgba(68, 255, 153, 0.9);
}
.agenda-time.disabled {
  background: rgba(120, 120, 120, 0.5);
}
.agenda-time-text {
  width: 100%;
  text-align: center;
  font-size: 21px;
  font-weight: 400;
  color: #ffffff;
}
.agenda-time.disabled div.agenda-time-text {
  color: rgba(50, 50, 50, 0.8);
}
.roxo,
p.agenda-date.roxo {
  color: #440099;
}
</style>
